var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('p',{staticStyle:{"color":"#9b9b9f","font-size":"15px"}},[_vm._v("沪ICP备20010476号-2. Powered by VGsoft Team. All rights reserved. Live Statistics")])])
}]

export { render, staticRenderFns }